var __default__ = {root:'m_8a5d1357'};
export default __default__;